module.exports = __webpack_public_path__ + "c7aed5c7999888b80946e28f93294762.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/image5.png
 ** module id = 283
 ** module chunks = 0
 **/